firebird.factory('growlService', [
    'helperService',
    '$window',
    '$rootScope',
    function (helperService, $window, $rootScope) {
        var service = {
                calculateNotificationDelay: calculateNotificationDelay,
                formatNotification: formatNotification,
                show: show
            },
            title_separator = ': ',
            ellipsis = '...';

        let inCompactMode = false;

        $rootScope.$on('enable-compact-mode', onCompactModeReceived);

        return service;

        ////////////////////////

        function show(message, type, title, opt) {
            // Sanitize
            message = helperService.encodeHtml(message);
            title = helperService.encodeHtml(title);
            vdiRef = helperService.getVDIRef();

            if (
                !vdiRef?.showContentsOnTopOfVideo &&
                $window.$('#videoroom-videos > div[user]:not(.audioonly)').length > 0
            ) {
                // TODO: need alternative. Don't show alert on VDI if video is turned on
                return;
            }

            var delay,
                formattedNotification = {};

            formattedNotification = service.formatNotification(message, type, title);
            delay =
                opt && opt.manualDismiss
                    ? 0
                    : service.calculateNotificationDelay(formattedNotification.title, formattedNotification.message);

            if (formattedNotification.title) {
                formattedNotification.title =
                    '<span data-private><strong>' + formattedNotification.title + '</strong></span>';
            }

            if (formattedNotification.message) {
                formattedNotification.message = '<span data-private>' + formattedNotification.message + '</span>';
            }
            if (inCompactMode) {
                showToastNotification(message, type, title);
            } else {
                $.growl(
                    {
                        title: formattedNotification.title,
                        message: formattedNotification.message
                    },
                    {
                        type: type,
                        allow_dismiss: opt && opt.manualDismiss ? true : false,
                        label: 'Cancel',
                        className: 'btn-xs btn-inverse',
                        placement: {
                            from: 'top',
                            align: 'right'
                        },
                        delay: delay,
                        animate: {
                            enter: 'animated bounceIn',
                            exit: 'animated bounceOut'
                        },
                        offset: {
                            x: 20,
                            y: 85
                        }
                    }
                );
            }
        }

        // estimates how long it will take to read the notification
        function calculateNotificationDelay(title, message) {
            var wpm = 180, // readable words per minute
                word_length = 5, // standardized number of chars in calculable word
                words_count,
                words_time,
                delay = 1500, // milliseconds before user starts reading the notification
                bonus = 0, // extra time
                min_time = 2500, // minimum time
                max_time = 6000, // maximum time
                combinedText;

            try {
                combinedText = title + message;

                if (combinedText) {
                    words_count = combinedText.length / word_length;
                    words_time = (words_count / wpm) * 60 * 1000;

                    var result = delay + words_time + bonus;

                    if (result > max_time) {
                        return max_time;
                    } else if (result < min_time) {
                        return min_time;
                    } else {
                        return result;
                    }
                } else {
                    return min_time;
                }
            } catch (err) {
                return min_time;
            }
        }

        function formatNotification(message, type, title) {
            if (type === 'chat' || type === 'presenter-chat') {
                var max_length = 90; // max number of characters in the title

                if (title && title.length > max_length) {
                    return {
                        message: undefined,
                        title: title.substring(0, max_length).trim() + ellipsis
                    };
                } else {
                    var combinedText,
                        result = {
                            title: title + title_separator
                        };

                    if (title) {
                        combinedText = result.title + message;
                    } else {
                        combinedText = message;
                    }

                    if (combinedText && combinedText.length > max_length) {
                        if (message) {
                            result.message = message.substring(0, max_length - result.title.length).trim() + ellipsis;
                        } else {
                            result.message = message;
                        }
                        return result;
                    } else {
                        result.message = message;
                        return result;
                    }
                }
            } else {
                return {
                    message: message,
                    title: title ? title + title_separator : title
                };
            }
        }

        function showToastNotification(message, type, title) {
            let toastTimer = 4000;

            if (title) {
                message = title + title_separator + message;
            }

            if (type == 'chat' && message.length > 40) {
                message = message.slice(0, 40) + ellipsis;
            } else if (message.length > 116) {
                message = message.slice(0, 116) + ellipsis;
                toastTimer = 8000;
            }

            $rootScope.$broadcast('toast-notification', { show: true, message: message, type: type });

            setTimeout(function () {
                $rootScope.$broadcast('toast-notification', { show: false, message: '', type: null });
            }, toastTimer);
        }

        function onCompactModeReceived(e, data) {
            inCompactMode = data;
        }
    }
]);
